import React from 'react';
import { launchAmplifyCase } from '../case-detail/window-open-args';
import { caseUtils } from '@codametrix/ui-common';
import { BiomeIcon, IconName } from '@codametrix/verdigris';

const { getChildWindowParams } = caseUtils;
type errorSubmissionProps = {
  errorMessages: AmplifyAPI.AmplifyError[];
  customClaimsRelatedProps?: {
    cases: CMxAPI.CaseRun[];
    onOpenRelatedCase: (
      windowOpenArgs: CMxCommonApp.WindowOpenArguments
    ) => void;
    applyErrorTextStyle: boolean;
  };
  messageHeader?: string;
  messageStyle?: string;
  messageType?: 'warning' | 'error' | 'info';
};

/**
 * Little component function for display error message list
 * @param errorMessages
 * @returns
 */
const ErrorSubmission = (props: errorSubmissionProps) => {
  const {
    errorMessages,
    messageHeader,
    messageStyle,
    messageType,
    customClaimsRelatedProps
  } = props;

  const caseHandler = (customClaim, index) => {
    const childWindowParams: CMxCommonApp.WindowOpenArguments = getChildWindowParams(
      customClaim?.case_uid,
      customClaim?.process_instance_guid,
      customClaim?.service_line,
      launchAmplifyCase,
      customClaim?.case_id
    );
    if (
      customClaimsRelatedProps &&
      customClaimsRelatedProps.onOpenRelatedCase
    ) {
      customClaimsRelatedProps.onOpenRelatedCase(childWindowParams);
    }
  };

  const getMessageDetails = (message: string) => {
    const messages = {
      warning: { icon: IconName.Warning, text: 'Warning' },
      error: { icon: IconName.Error, text: 'Error' },
      info: { icon: IconName.Info, text: 'Info' }
    };

    return messages?.[message] || { icon: IconName.Info, text: 'Info' };
  };

  return (
    <>
      {errorMessages?.length > 0 && (
        <>
          <div
            className={`${messageStyle} ${messageType} ${
              customClaimsRelatedProps?.applyErrorTextStyle ? 'error-text' : ''
            }`}>
            <div className="message-icon-container">
              <BiomeIcon
                iconName={getMessageDetails(messageType).icon}
                iconClass="message-icon"
                titleText={getMessageDetails(messageType).text}
              />
            </div>
            <div className="message-container">
              {messageHeader && <h1>{messageHeader}</h1>}

              <ul className="error-submission">
                {customClaimsRelatedProps?.cases?.length > 0 && (
                  <li>
                    There are cross case CCI issues for these cases.
                    <ul>
                      {customClaimsRelatedProps?.cases.map(
                        (customClaim, idx) => (
                          <li
                            key={idx}
                            className={`case-clickable`}
                            onClick={() => caseHandler(customClaim, idx)}>
                            {customClaim?.case_id}
                          </li>
                        )
                      )}
                    </ul>
                  </li>
                )}

                {errorMessages.map((errorMessage, idx) => (
                  <li
                    key={idx}
                    className={
                      customClaimsRelatedProps &&
                      !customClaimsRelatedProps.applyErrorTextStyle
                        ? ''
                        : 'error-text'
                    }>
                    {errorMessage.message}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
};

ErrorSubmission.displayName = 'ErrorSubmission';

export default ErrorSubmission;
